export const fields = [
  {
    dataIndex: "roleId",
    key: "roleId",
    title: "角色编号",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "roleName",
    key: "roleName",
    title: "角色名称",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "num",
    key: "num",
    title: "用户数",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "statusStr",
    key: "statusStr",
    title: "角色状态",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "updateTime",
    key: "updateTime",
    title: "操作时间",
    isShow: true,
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 200,
    scopedSlots: {
      customRender: "action",
    },
    isShow: true,
  },
];
export const slotOpt = [
  {
    slot: "action",
    component: "Action",
    list: [
      { name: "编辑", cb: "edit", divider: false },
      { name: "删除", cb: "singleDelete", divider: true },
      { name: "分配用户", cb: "divider", divider: true },
    ],
  },
];

export const distributionColumns = [
  {
    title: "序号",
    dataIndex: "key",
    width: 50,
    isShow: true,
  },
  {
    title: "用户名称",
    dataIndex: "nickName",
    width: 100,
    isShow: true,
  },
  {
    title: "账号",
    dataIndex: "name",
    isShow: true,
  },
  {
    title: "邮箱",
    dataIndex: "email",
    isShow: true,
  },
  {
    title: "手机号码",
    dataIndex: "phonenumber",
    isShow: true,
  },
];

export const userColumns = [
  {
    title: "序号",
    dataIndex: "key",
    width: 50,
    isShow: true,
  },
  {
    title: "账号",
    dataIndex: "userName",
    isShow: true,
  },
  {
    title: "名称",
    dataIndex: "nickName",
    isShow: true,
  },
  {
    title: "邮箱",
    dataIndex: "email",
    isShow: true,
  },
];
